import React from "react"
import { IconMenu, IconButton, FontIcon, MenuItem } from "material-ui"
import strings from "../../../localization/strings"
import * as reportAction from "../../../actions/ReportAction"
import { IDate } from "../../../models"

interface IProps {
    utcTime: IDate
    globalHierarchyItemId: string
    filterByPunchPermissionHierarchy: boolean
    filterDirectReportsOnly: boolean
}

const DashboardWorkingEmployeeReports: React.SFC<IProps> = (props: IProps) => {
    return (
        <div style={{ marginTop: -10, marginLeft: 5 }}>
            <IconMenu
                style={{ padding: 0 }}
                iconButtonElement={
                    <IconButton data-intercom-target={"Dashboard-WorkingEmployee-Page-Report"} tooltip={strings.Reports}>
                        <FontIcon className="fa fa-file-text itemActionButton" style={{ fontSize: 20 }} />
                    </IconButton>
                }
            >
                <MenuItem
                    data-intercom-target={"Dashboard-WorkingEmployee-Page-Download"}
                    primaryText={strings.Download}
                    leftIcon={<FontIcon className="fa fa-file-excel-o" />}
                    onTouchTap={() =>
                        reportAction.getDashboardWorkingEmployeesDownloadReport(
                            props.globalHierarchyItemId,
                            props.utcTime,
                            props.filterDirectReportsOnly,
                            props.filterByPunchPermissionHierarchy
                        )
                    }
                />
                <MenuItem
                    data-intercom-target={"Dashboard-WorkingEmployee-Page-Attendance-Emergency"}
                    primaryText={strings.Attendance_and_Emergency}
                    leftIcon={<FontIcon className="fa fa-file-pdf-o" />}
                    onTouchTap={() =>
                        reportAction.getDashboardWorkingEmployeesAttendanceEmergencyReport(
                            props.globalHierarchyItemId,
                            props.utcTime,
                            props.filterDirectReportsOnly,
                            props.filterByPunchPermissionHierarchy
                        )
                    }
                />
            </IconMenu>
        </div>
    )
}

export default DashboardWorkingEmployeeReports